export default __webpack_public_path__ + "static/media/charalambides-christis.64e7cab4.jpg";